export default __webpack_public_path__ + "static/media/bh4.0359d0c6.webp";